import React, { useState, useEffect } from "react";
import { processSalary } from "../../api/salaryApi";
import { getAllDepartment } from "../../api/departmentApi";
import { getAllSection } from "../../api/sectionApi";
import { getAllAllowance } from "../../api/allowanceApi";
import { getAllDeduction } from "../../api/deductionApi";

import { hasRight } from "../../utils/userRights"; 

export default function SalaryProcess() {
  const [departments, setDepartments] = useState([]);
  const [sections, setSections] = useState([]);
  const [allowancesMaster, setAllowancesMaster] = useState([]);
  const [deductionsMaster, setDeductionsMaster] = useState([]);

  const [deptID, setDeptID] = useState("");
  const [sectionID, setSectionID] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [salaryData, setSalaryData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dept = await getAllDepartment();
        const sec = await getAllSection();
        const allowanceMaster = await getAllAllowance();
        const deductionMaster = await getAllDeduction();

        setDepartments(dept);
        setSections(sec);
        setAllowancesMaster(allowanceMaster);
        setDeductionsMaster(deductionMaster);
      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };
    fetchData();
  }, []);

  const handleProcessSalary = async () => {
    setIsDisabled(true); 
    setErrorMessage("");
    try {
      const data = await processSalary({
        month: parseInt(month),
        year: parseInt(year),
        deptID: deptID ? parseInt(deptID) : null,
        sectionID: sectionID ? parseInt(sectionID) : null,
        // crUser: "admin", sessionStorage.getItem("username")
        crUser: sessionStorage.getItem("username"),
        crDate: new Date().toISOString(),
      });
      setSalaryData(data);
    } catch (error) {
      setSalaryData([]);
      setErrorMessage(error.message);
    }
  };

  const handleClear = () => {
     setIsDisabled(false); 
    setDeptID("");
    setSectionID("");
    setMonth("");
    setYear("");
    setSalaryData([]);
    setErrorMessage("");
  };
  // Map allowance1 -> AllowanceMaster name
  // const mapAllowances = (row) => {
  //   return allowancesMaster.map((item, index) => ({
  //     name: item.allowanceName,
  //     value: row[`allowance${index + 1}`] || 0,
  //   }));
  // };

  const totals = salaryData.reduce((acc, item) => {
  // Dynamically sum allowances
    allowancesMaster.forEach((_, index) => {
      const key = `allowance${index + 1}`;
      acc[key] = (acc[key] || 0) + (item[key] || 0);
    });
  
    // Dynamically sum deductions
    deductionsMaster.forEach((_, index) => {
      const key = `deduction${index + 1}`;
      acc[key] = (acc[key] || 0) + (item[key] || 0);
    });
  
    // Sum total allowance, total deduction, and net salary
    acc.totalAllowance += item.totalAllowance || 0;
    acc.totalDeduction += item.totalDeduction || 0;
    acc.netSalary += item.netSalary || 0;
  
    return acc;
  }, {
    // Initialize with dynamic keys
    ...Object.fromEntries(allowancesMaster.map((_, i) => [`allowance${i + 1}`, 0])),
    ...Object.fromEntries(deductionsMaster.map((_, i) => [`deduction${i + 1}`, 0])),
    totalAllowance: 0,
    totalDeduction: 0,
    netSalary: 0
  });

  const mapAllowances = (row) => {
    return allowancesMaster.map((item, index) => {
      console.log("Index:", index, "Allowance:", item.allowanceName); // Print index & name
      return {
        name: item.allowanceName,
        value: row[`allowance${index + 1}`] || 0,
      };
    });
  };

  const mapDeductions = (row) => {
    return deductionsMaster.map((item, index) => {
      console.log("Index:", index, "Allowance:", item.deductionName); // Print index & name
      return {
      name: item.deductionName,
      value: row[`deduction${index + 1}`] || 0,
      };
    });
  };

  return (
    <div className="container mt-4">
      <h2>Salary Process</h2>

      <div className="row mb-3">
        <div className="col-3">
          <label>Department</label>
          <select className="form-select form-select-sm" value={deptID} onChange={(e) => setDeptID(e.target.value)}>
            <option value="">All Department</option>
            {departments.map((d) => <option key={d.departmentID} value={d.departmentID}>{d.departmentName}</option>)}
          </select>
        </div>

        <div className="col-3">
          <label>Section</label>
          {/* <select className="form-select form-select-sm" value={sectionID} onChange={(e) => setSectionID(e.target.value)}>
            <option value="">Select Section</option>
            {sections.map((s) => <option key={s.sectionID} value={s.sectionID}>{s.sectionName}</option>)}
          </select> */}
          <select className="form-select form-select-sm" value={sectionID} onChange={(e) => setSectionID(e.target.value)}>
            <option value="">All Section</option>
              {sections
                .filter((s) => s.departmentID === parseInt(deptID)) // now works
                .map((s) => (
                  <option key={s.sectionID} value={s.sectionID}>
                    {s.sectionName}
                  </option>
                ))}
         </select>
        </div>

        <div className="col-2">
          <label>Month(1-12)</label>
          <input type="number" placeholder="Month (1-12)" value={month} min="1" max="12" 
          // onChange={(e) => setMonth(e.target.value)}
          onChange={(e) => {
              let value = e.target.value;
              if (value === "" || (value >= 1 && value <= 12)) {
                setMonth(value);
              }
            }} 
          className="form-control form-control-sm" />
        </div>

        <div className="col-2">
          <label>Year(YYYY)</label>
          <input type="number" value={year} 
          // onChange={(e) => setYear(e.target.value)}
          onChange={(e) => {
              let value = e.target.value;
              if (value.length <= 4) {
                setYear(value);
              }
            }} 
          className="form-control form-control-sm" />
        </div>

        <div className="col-2 d-flex align-items-end">
          <button onClick={handleProcessSalary} className="btn btn-primary btn-sm" disabled={isDisabled}>{isDisabled ? "Processing..." : "Process Salary"}</button>
        </div>
      </div>

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      {salaryData.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th style={{ textAlign: "center" }}>Sr.No.</th>
                <th style={{ textAlign: "left", minWidth: "120px" }}>Employee Name</th>
                {allowancesMaster.map((a) => <th key={a.allowanceID} style={{ textAlign: "left" }}>{a.allowanceName}</th>)}
                <th style={{ textAlign: "left" }}>Total Allowance</th>
                {deductionsMaster.map((d) => <th key={d.deductionID} style={{ textAlign: "left" }}>{d.deductionName}</th>)}
                <th style={{ textAlign: "left" }}>Total Deduction</th>
                <th style={{ textAlign: "left" }}>Net Salary</th>
              </tr>
            </thead>
            <tbody>
              {salaryData.map((row, idx) => {
                const mappedAllowances = mapAllowances(row);
                const mappedDeductions = mapDeductions(row);

                return (
                  <tr key={idx}>
                    <td style={{ textAlign: "center" }}>{idx + 1}</td>
                    <td style={{ textAlign: "left" }}>{row.employeeName}</td>
                    {mappedAllowances.map((a, i) => <td key={i} style={{ textAlign: "right" }}>{a.value}</td>)}
                    <td>{row.totalAllowance}</td>
                    {mappedDeductions.map((d, i) => <td key={i} style={{ textAlign: "right" }}>{d.value}</td>)}
                    <td style={{ textAlign: "right" }}>{row.totalDeduction}</td>
                    <td style={{ textAlign: "right" }}>{row.netSalary}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className="font-bold bg-gray-100">
                <td colSpan={2} style={{ textAlign: "center" }}>Total</td>

                {/* Dynamically render allowance totals */}
                {allowancesMaster.map((_, index) => (
                  <td key={`allowance-${index}`} style={{ textAlign: "right" }}>
                    {totals[`allowance${index + 1}`]?.toFixed(0) || "0"}
                  </td>
                ))}

                {/* Total Allowance */}
                <td style={{ textAlign: "right" }}>{totals.totalAllowance?.toFixed(2) || "0"}</td>
              
                {/* Dynamically render deduction totals */}
                {deductionsMaster.map((_, index) => (
                  <td key={`deduction-${index}`} style={{ textAlign: "right" }}>
                    {totals[`deduction${index + 1}`]?.toFixed(0) || "0"}
                  </td>
                ))}

                {/* Total Deduction */}
                <td style={{ textAlign: "right" }}>{totals.totalDeduction?.toFixed(0) || "0"}</td>
              
                {/* Net Salary */}
                <td style={{ textAlign: "right" }}>{totals.netSalary?.toFixed(0) || "0"}</td>
              </tr>
            </tfoot>

          </table>
        </div>
      )}
      <div>
        <button onClick={handleClear} className="btn btn-secondary btn-sm" >Clear</button>
      </div>
    </div>
  );
}
